/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BrokernetLanguageType {
    De = 'De',
    En = 'En'
  }

    export const BrokernetLanguageTypeTranslocoMap: Record<BrokernetLanguageType, string> = {
    [BrokernetLanguageType.De]: 'brokernetLanguageType.de',
    [BrokernetLanguageType.En]: 'brokernetLanguageType.en',
    };

    export const BrokernetLanguageTypeOptions = [
  { value: BrokernetLanguageType.De, labelKey: 'brokernetLanguageType.de' },
  { value: BrokernetLanguageType.En, labelKey: 'brokernetLanguageType.en' },
    ];

